import {createFileRoute} from '@tanstack/react-router';
import ClubOverview from '../../../../clubs/dashboard/ClubOverview';

// The redesigned analytics OVERVIEW — deliberately a separate piece from /dashboard (its own
// endpoint and page), behind the same server-side new_dashboard flag/allowlist.
export const Route = createFileRoute('/_app/clubs/$club_uid/overview')({
    component: () => {
        const {club_uid} = Route.useParams();
        return <ClubOverview clubUid={club_uid} />;
    },
});
